import React from 'react'
import Select, { CSSObjectWithLabel, StylesConfig } from 'react-select'
import './index.scss'

type SelectOption = { value: string; label: string }

export const CustomSelect = ({
  label,
  value,
  onChange,
  name,
  placeholder,
  options,
  error,
  onInputChange,
  loading,
  inputRef
}: {
  label: string,
  value: { value: string, label: string },
  onChange: any,
  onInputChange?: any,
  name: string,
  type: string,
  placeholder: string,
  options: { value: string, label: string }[],
  error?: string,
  loading?: boolean,
  inputRef?: React.RefObject<any>,
}) => {

  const inputId = `${name}-input`

  const styles: StylesConfig<SelectOption, false> = {
    control: (baseStyles) =>
      ({
        ...baseStyles,
        borderColor: '#949494!important',
        borderRadius: '0x',
        padding: '7px 10px'
      }) as CSSObjectWithLabel,
    placeholder: (baseStyles) =>
      ({
        ...baseStyles,
        color: '#949494'
      }) as CSSObjectWithLabel,
    option: (baseStyles, { isFocused, isSelected }) =>
      ({
        ...baseStyles,
        color: '#212529',
        backgroundColor: isFocused ? '#eee' : isSelected ? '#eee' : '#fff',
        ':hover': {
          backgroundColor: '#eee'
        },
        ':active': {
          backgroundColor: '#eee'
        }
      }) as CSSObjectWithLabel,
    singleValue: (baseStyles) =>
      ({
        ...baseStyles,
        color: '#212529'
      }) as CSSObjectWithLabel
  }

  return (
    <div className='custom-input'>
      <label htmlFor={inputId}>{label}</label>
      <Select<SelectOption>
        aria-label={label}
        ref={inputRef}
        id={inputId}
        styles={styles}
        defaultInputValue=''
        name={name}
        value={value.value ? value : null}
        onInputChange={onInputChange}
        onChange={(e) => {
          onChange(name, typeof e === 'object' ? e?.value : '')
        }}
        placeholder={placeholder}
        options={options}
        noOptionsMessage={() => !loading ? (
          'No options'
        ) : (
          <div className='custom-select-loading-holder'>
            <div className="loader"></div>
          </div>
        )}
      />
      {error && <p className='error'>{error}</p>}
    </div>
  )
}